import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  CustomFormFieldsFragment,
  CustomFormListFieldsFragment,
  GetCustomFormDocument,
  GetCustomFormQuery,
  GetCustomFormQueryVariables,
  GetCustomFormsDocument,
  GetCustomFormsQuery,
  GetCustomFormsQueryVariables
} from '~/api/graphql';

export const getCustomForms = async () =>
  queryData<GetCustomFormsQuery, GetCustomFormsQueryVariables, CustomFormListFieldsFragment[]>(
    client,
    { query: GetCustomFormsDocument },
    (data) => data?.customForms || []
  );

export const getCustomForm = async (id: string) =>
  queryData<GetCustomFormQuery, GetCustomFormQueryVariables, CustomFormFieldsFragment>(
    client,
    {
      query: GetCustomFormDocument,
      variables: { id: id },
      fetchPolicy: 'network-only'
    },
    (data) => data?.customForm
  );

export const loadCustomForms: LoaderFunction = () =>
  loadQuery(getCustomForms(), { suppressAuthErrors: true });

export const loadCustomForm: LoaderFunction = ({ params }) =>
  loadQuery(getCustomForm(params.id || ''));
